import firebase from 'firebase/app'
import 'firebase/auth';
import gen from '../gen'

const state = {
  //
  authLoader : true,
  //
  isLoggedIn: false,
  user: {}
}

const getters = {
  authLoader: state => state.authLoader,
  //
  isLoggedIn: state => state.isLoggedIn,
  user: state => state.user
}

const mutations = {
  //
  logout(state2) {
    //
    firebase.auth().signOut().then(function () {
      console.log('// Sign-out successful.')
      localStorage.removeItem('homePageImages')
      localStorage.removeItem('uploader')
      //
      //window.location.reload()
      //
    }).catch(function (error) {
      console.log('// Logout // An error happened.')
    });
    //
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/auth.js